// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8097":"1dea214279ddb6d6","9223":"9569e94f2ce99a39"}[chunkId] + ".js";
};